import React from 'react';
import { Link } from 'react-router-dom';

// Replace with a better, clear image for background
const backgroundImageUrl =
  'https://pbs.twimg.com/media/F2CajW8X0AAOdDz?format=jpg&name=large'; // Campus-style photo

const HomePage = () => {
  return (
    <div style={styles.background}>
      {/* Hero Section */}
      <div style={styles.hero}>
        <div style={styles.heroContent}>
          <img
            src="https://www.thogotottc.ac.ke/images/logo.png"
            alt="Thogoto TTC Logo"
            style={styles.logo}
          />
          <h1 style={styles.heroTitle}>
            Welcome to the Thogoto T.T.C Student Leave Management System
          </h1>
          <p style={styles.heroDescription}>
            Simplifying leave management for students with an intuitive, secure, and efficient platform.
          </p>
          <Link to="/login" style={styles.ctaButton}>
            Get Started
          </Link>
        </div>
      </div>

      {/* Features Section */}
      <div style={styles.featuresSection}>
        <div style={styles.featuresContainer}>
          <h2 style={styles.featuresTitle}>How It Works</h2>
          <div style={styles.featureGrid}>
            {/* Feature 1 */}
            <div style={styles.featureCard}>
              <h3 style={styles.featureCardTitle}>Apply Online</h3>
              <p style={styles.featureCardDescription}>
                Submit your leave requests through a simple and user-friendly online form.
              </p>
            </div>

            {/* Feature 2 */}
            <div style={styles.featureCard}>
              <h3 style={styles.featureCardTitle}>Track Status</h3>
              <p style={styles.featureCardDescription}>
                Monitor the progress of your leave applications in real-time.
              </p>
            </div>

            {/* Feature 3 */}
            <div style={styles.featureCard}>
              <h3 style={styles.featureCardTitle}>Receive Notifications</h3>
              <p style={styles.featureCardDescription}>
                Get instant updates when your leave request is approved or rejected.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

// Styles
const styles = {
  background: {
    fontFamily: "'Poppins', sans-serif",
    margin: 0,
    padding: 0,
    boxSizing: 'border-box',
  },

  // Hero Section
  hero: {
    backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 10)), url(${backgroundImageUrl})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    minHeight: '100vh',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    color: 'white',
    padding: '2rem',
  },
  heroContent: {
    textAlign: 'center',
    maxWidth: '700px',
  },
  logo: {
    width: '300px',
    marginBottom: '2rem',
  },
  heroTitle: {
    fontSize: '3rem',
    fontWeight: 'bold',
    marginBottom: '1rem',
    textTransform: 'uppercase',
    letterSpacing: '2px',
    textShadow: '2px 2px 6px rgba(0, 0, 0, 0.6)',
    fontFamily: "'Playfair Display', serif",
  },
  heroDescription: {
    fontSize: '1.2rem',
    lineHeight: '1.6',
    marginBottom: '2rem',
    fontFamily: "'Lora', serif",
  },
  ctaButton: {
    display: 'inline-block',
    padding: '0.8rem 2rem',
    fontSize: '1rem',
    fontWeight: 'bold',
    color: '#fff',
    backgroundColor: '#007BFF',
    borderRadius: '50px',
    textDecoration: 'none',
    transition: 'transform 0.3s, box-shadow 0.3s',
  },

  // Features Section
  featuresSection: {
    padding: '6rem 1rem',
    backgroundColor: '#f9f9f9',
  },
  featuresContainer: {
    maxWidth: '1200px',
    margin: '0 auto',
    textAlign: 'center',
  },
  featuresTitle: {
    fontSize: '2.5rem',
    fontWeight: 'bold',
    marginBottom: '3rem',
    color: '#333',
    fontFamily: "'Playfair Display', serif",
  },
  featureGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
    gap: '2rem',
  },
  featureCard: {
    backgroundColor: '#fff',
    padding: '2rem',
    borderRadius: '10px',
    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.05)',
  },
  featureCardTitle: {
    fontSize: '1.5rem',
    fontWeight: 'bold',
    marginBottom: '1rem',
    color: '#007BFF',
    fontFamily: "'Playfair Display', serif",
  },
  featureCardDescription: {
    fontSize: '1rem',
    lineHeight: '1.6',
    color: '#555',
    fontFamily: "'Lora', serif",
  },
};

export default HomePage;
